import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CoreApisService } from '../core-apis.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-powerful-apis',
  templateUrl: './powerful-apis.component.html',
  styleUrls: ['./powerful-apis.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class PowerfulApisComponent implements OnInit {
  constructor(private coreApiPageService: CoreApisService) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  streamlineData: any;
  subscriptions: Subscription[];

  ngOnInit(): void {
    this.coreApiPageService.powerfulApi$.subscribe(data => {
      this.streamlineData = {
        header: data?.title,
        tagName: data?.components[0]?.fields?.tagName.toUpperCase(),
        cards: data?.component1,
        description: data?.content?.content[0]?.content[0]?.value,
        // comingSoon: data[2]?.fields?.iconText
      };
    });
  }
}
